import { observable } from 'mobx'

export type DialogItemComponentConstructor = (props: {
  dialogItem: DialogItem
}) => React.ReactElement

type DialogItemActive = {
  resolveDialog: (reason: string) => void
  rejectDialog: (error: Error) => void
  dialogFinished: Promise<string>
}

export type DialogItem = {
  id: string
  component: DialogItemComponentConstructor
  active?: DialogItemActive
  onActivation?: (di: DialogItem) => void
}

export const init = (dialogs = []): DialogItem[] => observable(dialogs)
